import { Injectable } from '@angular/core';
import { Role } from '@app/models/account/role.model';

@Injectable()
export class GetRolesFor {
    public company(id): Promise<[Role[], any]> {
        return Role.where('company_id', id).all();
    }
}
